import React from "react";
import PropTypes from "prop-types";
import { NumberFormatBase, NumericFormat } from "react-number-format";

export const NumberFormat = ({ inputRef, onChange, ...props }) => (
  <NumberFormatBase
    data-testid={props["data-testid"]}
    getInputRef={inputRef}
    onValueChange={({ value }) => {
      onChange({
        target: {
          name: props.name,
          value: value == null ? "" : String(value)
        }
      });
    }}
    isNumericString
    {...props}
  />
);

NumberFormat.propTypes = {
  inputRef: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  "data-testid": PropTypes.string
};

export const POBoxNumberInput = props => (
  <NumberFormat allowNegative={false} decimalSeparator={false} {...props} />
);

POBoxNumberInput.propTypes = {
  ...NumberFormat.propTypes
};

export const DecimalNumberInput = ({ inputRef, onChange, ...props }) => (
  <NumericFormat
    data-testid={props["data-testid"]}
    getInputRef={inputRef}
    onValueChange={({ value }) => {
      onChange({
        target: {
          name: props.name,
          value: value == null ? "" : String(value)
        }
      });
    }}
    allowNegative={false}
    decimalSeparator="."
    thousandSeparator={false}
    decimalScale={2}
    {...props}
  />
);

DecimalNumberInput.propTypes = {
  inputRef: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  "data-testid": PropTypes.string
};
